<template>
  <div class="data-content">
    <h4>选择报告模板</h4>

    <div className="colorbar" style="display: none">
      <canvas width="55" height="8" id="gold"></canvas>
      <canvas width="55" height="8" id="wood"></canvas>
      <canvas width="55" height="8" id="water"></canvas>
      <canvas width="55" height="8" id="fire"></canvas>
      <canvas width="55" height="8" id="soil"></canvas>
    </div>
    <p v-if="reportTemplates.length > 0 && userReportTemplates.length > 0">
      <el-radio-group v-model="checkedTemplate">
        <el-radio
          border
          v-for="item in reportTemplates"
          :key="item.template"
          :label="item.template"
          class="m-3 report_template"
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
    </p>
    <el-button type="primary" @click="actionSubmit">{{
      $t("project.c_report")
    }}</el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { createReport, zscoreReport, report_types } from "../../api/api";
import { Loading } from "element-ui";

export default {
  components: {},
  props: {
    subject_id: {
      type: String,
      default: "",
    },
    task_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
      user_rights: localStorage.getItem("user_rights")
        ? JSON.parse(localStorage.getItem("user_rights"))
        : {},
      userReportTemplates: [],
      checkedTemplate: 0, //默认选中的模板id
      reportTemplates: [
        // {
        //   template: 1,
        //   name: "脑结构分析报告",
        // },
        // {
        //   template: 2,
        //   name: "脑结构分析报告 II",
        // },
        // {
        //   template: 3,
        //   name: "脑龄评估报告",
        // },
        {
          template: 4,
          name: "脑健康评估报告",
        },
        {
          template: 5,
          name: "脑健康评估报告 II",
        },
        {
          template: 10,
          name: "脑健康评估报告 III",
        },
        {
          template: 6,
          name: "全脑结构评估报告",
        },
        {
          template: 7,
          name: "大脑 - 脏腑评估报告",
        },
        {
          template: 8,
          name: "大脑 - 中医情志评估报告",
        },
        {
          template: 9,
          name: "大脑 - 经络评估报告",
        },
      ],
      elements: [
        {
          name: "gold",
          colors: [
            [140, 140, 140],
            [217, 217, 217],
            [245, 245, 245],
          ],
        },
        {
          name: "wood",
          colors: [
            [56, 158, 13],
            [115, 209, 61],
            [183, 235, 143],
          ],
        },
        {
          name: "water",
          colors: [
            [83, 29, 171],
            [146, 84, 222],
            [211, 173, 247],
          ],
        },
        {
          name: "fire",
          colors: [
            [207, 19, 34],
            [255, 77, 79],
            [255, 163, 158],
          ],
        },
        {
          name: "soil",
          colors: [
            [212, 177, 6],
            [255, 236, 61],
            [255, 251, 143],
          ],
        },
      ],
      zscore_params: [-2.5, 0, 2.5],
      zscore_colors: {
        zscore_echart: [], //后端 brainlabel/zscore_report 取脑区后，计算出颜色 [r,g,b] 用于报告前端生饼图
        zscore_images: [], //后端 brainlabel/zscore_report 取脑区后，计算出颜色 [r,g,b] 用于adaptor 生3D图
      },
    };
  },

  computed: {
    ...mapState({
      lang: (state) => state.language,
      url_backendapi: (state) => state.url_backendapi, //:28801
      url_adaptorapi: (state) => state.url_adaptorapi, //:28000
    }),
  },
  filters: {},
  watch: {},
  methods: {
    actionSubmit() {
      const me = this;
      if (me.checkedTemplate <= 0) {
        this.$helper.errNotify("请选择报告模板");
        return;
      }
      //中医版，先获取zscore并计算颜色
      if ([7, 8, 9].includes(me.checkedTemplate)) {
        me.getLableZscores();
        return;
      }

      me.fetchpost();
    },
    async fetchpost() {
      const me = this;
      const postdata = {
        task_id: me.task_id,
        zscore_colors: me.zscore_colors,
        checkedTemplate: me.checkedTemplate,
      };

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        let res = await createReport(postdata);
        if (res.status === 200) {
          me.$message({
            message: res.message || "报告已创建，请等待生成",
            type: "success",
          });

          me.$router.push(
            "/report/list?subject_id=" +
              me.subject_id +
              "&task_id=" +
              me.task_id
          );
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    //中医相关
    drawColorBars() {
      const me = this;
      me.elements.forEach((ele) => {
        var _minColor = ele.colors[0]; // this.minColor; //"rgba(90,0,255, 255,255)";
        var _midColor = ele.colors[1]; // this.midColor; //"rgba(213,202,236,255)";
        var _maxColor = ele.colors[2]; // this.maxColor; //"rgba(48,9,121,255)";

        let colorbar_options = {
          //colors:['#fc0000','#666049','#0bf3f1'],
          colors: me.colorbar_colorful(_minColor, _midColor, _maxColor), //64个颜色值
          values: me.zscore_params, // [-2.5, 0, 2.5],
        };
        //colorbar.empty().append('<canvas id="colorbarcanvas" width="150" height="5"></canvas>');
        me.drawcolorbar(ele.name, colorbar_options);
      });
    },
    drawcolorbar(id, params) {
      var dom = document.getElementById(id);

      var canvaser = dom.getContext("2d", { willReadFrequently: true });
      canvaser.rect(0, 0, dom.width, dom.height);

      var reg = /\d*px/gi;
      //canvaser.font = canvaser.font.replace(reg, 'large');
      var style = canvaser.createLinearGradient(0, 0, dom.width, dom.height);
      var len = params.colors.length - 1; //64个颜色值
      var percent = 1 / len;
      var values = params.values;
      //canvaser.font = '30px Arial';
      for (var i = 0; i <= len; i++) {
        var val = i * percent;
        style.addColorStop(val, params.colors[i]);
        //canvaser.fillText(values[i], val * dom.width * 0.95, dom.height);
        //canvaser.fillText(values[i], val * dom.width, dom.height);
      }
      canvaser.fillStyle = style;
      canvaser.fill();
    },

    getColorValue(rgb) {
      // var rgbvalue =
      //   /rgba?\(-?(\d+)\s*,\s*-?(\d+)\s*,\s*-?(\d+)\s*,\s*-?(\d+)\s*(,\s*-?\d+[\.\d+]*)*\)/g.exec(
      //     rgba
      //   ),
      //   r = parseInt(Math.abs(rgbvalue[1])),
      //   g = parseInt(Math.abs(rgbvalue[2])),
      //   b = parseInt(Math.abs(rgbvalue[3])),
      //   a = parseInt(Math.abs(rgbvalue[4]));

      return {
        R: rgb[0],
        G: rgb[1],
        B: rgb[2],
      };
    },
    colorbar_colorful(_minColor, _midColor, _maxColor) {
      var mincolor = this.getColorValue(_minColor),
        midColor = this.getColorValue(_midColor),
        maxcolor = this.getColorValue(_maxColor);

      var _colorMapLength = 64;

      var result = [];
      let rgbs = [];

      for (var i = 0; i < _colorMapLength; i++) {
        var mixFactor =
          Math.pow(i - _colorMapLength / 2, 2) /
          Math.pow(_colorMapLength / 2, 2);
        var selectColor = i < _colorMapLength / 2 ? _minColor : _maxColor;
        var useColor = this.getColorValue(selectColor);

        var red = parseInt(
          useColor.R * mixFactor + midColor.R * (1 - mixFactor)
        );
        var green = parseInt(
          useColor.G * mixFactor + midColor.G * (1 - mixFactor)
        );
        var blue = parseInt(
          useColor.B * mixFactor + midColor.B * (1 - mixFactor)
        );

        rgbs.push([red, green, blue]);
        var hexcolor = this.rgbToHex(red, green, blue);

        //result.push('rgb('+red+', '+green+', '+blue+', '+alpha+')');
        result.push("#" + hexcolor);
      }

      return result;
    },

    rgbToHex(r, g, b) {
      let hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      return hex;
    },

    getRGBColor(param) {
      //console.log(param.name);
      const me = this;
      let rgba = me.getCanvasColor(param.element, param.zscore);

      return [rgba[0], rgba[1], rgba[2]];
    },

    getCanvasColor(canvasid, x, y = 0) {
      //x = zscore value; y = 0;

      const colorbar_options = this.zscore_params; // [-2.5, 0, 2.5]
      var canvas = document.getElementById(canvasid),
        context = canvas.getContext("2d", { willReadFrequently: true });

      let imgData = context.getImageData(0, 0, canvas.width, canvas.height);

      let zscorelength =
        parseFloat(Math.abs(colorbar_options[0])) +
        parseFloat(colorbar_options[colorbar_options.length - 1]);

      var min = -zscorelength / 2,
        max = zscorelength / 2,
        colorx = 0;

      if (x < min) {
        colorx = 0;
      }

      if (x > max) {
        colorx = zscorelength;
      }

      if (x == 0) {
        colorx = max;
      }

      if ((x < 0 && x > min) || (x > 0 && x < max)) {
        colorx = max + x;
      }

      var pointx =
        colorx == 0
          ? 0
          : parseInt(((imgData.width - 0.0001) * colorx) / zscorelength);

      var imgpoint = context.getImageData(pointx, 0, 1, 1);

      var color = [
        //R,G,B,A
        imgpoint.data[0],
        imgpoint.data[1],
        imgpoint.data[2],
        imgpoint.data[3],
      ];

      return color;
    },
    async getLableZscores() {
      const me = this;

      let loadingInstance = Loading.service({
        background: "rgba(0, 0, 0, 0.7)",
      });

      const postdata = {
        task_id: me.task_id,
        checkedTemplate: me.checkedTemplate,
      };
      try {
        let json = await zscoreReport(postdata);
        if (json.status === 200) {
          json.post_params_echart.forEach((param) => {
            let rgb = me.getRGBColor(param);
            param["color"] = rgb;
          });

          json.post_params_images.forEach((param) => {
            //有固定色的不需要再生
            if (!param.color) {
              let rgb = me.getRGBColor(param);
              param["color"] = rgb;
            }
          });
          // [ {name: "Frontal", side: "left", label_name: "Frontal_L", zscore: -0.0244, shortname: "额叶_左"},...]
          let newImageParams = [];
          //console.log(json.post_params_images)
          //3D图 移除不需要脑区 , 交由前端处理，要脑区的颜色但不要脑区
          let exLists = [
            "Cingulate_L",
            "Cingulate_R",
            "CorpusCallosum_L",
            "CorpusCallosum_R",
          ];

          json.post_params_images.forEach((param, i) => {
            if (!exLists.includes(param.label_name)) {
              //console.log(param.label_name.toLowerCase())
              newImageParams.push(param);
            }
          });
          //console.log(newImageParams)
          // 用于报告前端生饼图
          me.zscore_colors.zscore_echart = json.post_params_echart;
          me.zscore_colors.zscore_images = newImageParams;
          me.zscore_colors.elements = me.elements;
          //  用于adaptor 生3D图

          me.fetchpost();
        }
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
        this.$helper.errNotify(error.message);
      }
    },
    async getReportTypes() {
      let reportTemplates = [];
      let userReportTemplates = [];
      if (
        this.user_rights &&
        this.user_rights.report_templates &&
        this.user_rights.report_templates.length
      ) {
        userReportTemplates = this.user_rights.report_templates;
      }
      try {
        let res = await report_types();
        if (res.status === 200 && res.data.length) {
          reportTemplates = res.data.filter(
            (item) =>
              item.template > 2 &&
              item.template < 11 &&
              userReportTemplates.includes(item.template)
          );

          //管理员
          if (this.user.role == 0) {
            reportTemplates = res.data.filter(
              (item) => item.template > 2 && item.template < 11
            );
            userReportTemplates = reportTemplates;
          }
        }

        console.log("reportTemplates", reportTemplates, userReportTemplates);

        this.reportTemplates = reportTemplates;
        this.userReportTemplates = userReportTemplates;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.drawColorBars();
    this.getReportTypes();
  },
};
</script>
<style lang="less" scoped>
.data-content {
  padding: 20px;
  .report_template {
    width: 240px;
  }
}
</style>